import * as core from '../../../../../../../core'

import { query } from './overview-metrics-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.metrics',
    description:
      'Displays overview metrics on a report card widget without Award Funding, IDC, or related metrics',
    name: 'RP Overview - Metrics',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
